<template>
  <svg
    :width="props.size"
    :height="props.size"
    viewBox="0 0 24 24"
    fill="currentColor"
    :class="{ spinning: spinning }"
    class="qicon"
  >
    <path :d="props.path" />
  </svg>
</template>

<script setup lang="ts">
import { computed, withDefaults } from 'vue';

interface Props {
  path: string;
  size?: number;
  color?: string; // QuillUI Icon doesn't support color, so we'll ignore this
  spin?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  size: 24,
  color: 'currentColor',
  spin: false,
});

const spinning = computed(() => {
  return props.spin || props.path.includes('M12,4V2A10');
});
</script>

<style scoped>
.qicon {
  display: inline-block;
  vertical-align: middle;
  flex-shrink: 0;
  line-height: 1;
}

/* Spinning animation */
.spinning {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
